<template>
  <div id="app">
    <div style="width: 100%;height: 0.18rem;background-color: antiquewhite;position: fixed;top: 0;left: 0;z-index: 100;">
      <nav_s></nav_s>
    </div>
    <div>
        <router-view v-wechat-title='$route.meta.title' />
    </div>
  </div>
</template>

<script>
  import nav_s from './views/common/nav'
  export default {
    name: 'App',
    components:{
      nav_s
    },
    provide(){
      return{
      }
    },
    data(){
      return{
        
      }
    },
  }
</script>

<style>
  #app {
    width: 100%;
    height: 100%;
    background: #ffffff;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue